// extracted by mini-css-extract-plugin
module.exports = {"toggle-button":"TaskStatusSelect_toggle-button__3YICh"};